<template>
  <section class="mt-4">
    <ul>
      <template v-for="(product, idx) in products">
        <SearchResultItem
          v-if="product"
          :key="product.id"
          :index="idx"
          :term="searchTerm"
          section="product"
          :to="toLocalePath(getProductDetailRoute(product)).toString()"
          :image-url="
            showImages ? (getFirstModelImage(product.images)?.hash ?? '') : ''
          "
          @click:result="$emit('click:result')"
        >
          {{ getName(product) }}
        </SearchResultItem>
      </template>
      <!-- category -->

      <template v-for="(category, idx) in categories">
        <SearchResultItem
          v-if="category"
          :key="category.id"
          :term="searchTerm"
          :index="idx"
          section="category"
          :to="toLocalePath(category.path).toString()"
          @click:result="$emit('click:result')"
        >
          {{ generateCategorySuggestionResult(category) }}
        </SearchResultItem>
      </template>
    </ul>
  </section>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { Category, Product } from '@scayle/storefront-nuxt'
import { getFirstAttributeValue } from '@scayle/storefront-nuxt'
import useRouteHelpers from '../../composables/useRouteHelpers'
import { getFirstModelImage } from '../../utils/image'
import { getProductDetailRoute } from '~/utils/route'

defineProps({
  searchTerm: {
    type: String as PropType<string>,
    default: '',
  },
  products: {
    type: Array as PropType<Product[]>,
    default: () => [],
  },
  categories: {
    type: Array as PropType<Category[]>,
    default: () => [],
  },
  showImages: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

defineEmits(['click:result'])

const { toLocalePath } = useRouteHelpers()

const generateCategorySuggestionResult = (category: Category) => {
  if (!category.parent?.name) return category.name

  const parentLabel = category.parent.parent?.name || category.parent.name
  return `${category.name} (${parentLabel})`
}

const getName = (product: Product) =>
  getFirstAttributeValue(product.attributes, 'name')?.label || ''
</script>
